<template>
  <div
    @click="handleClick"
    class="_ml-button"
    :style="
      `width: ${width};background: ${backgroundColor};border: 1px solid ${borderColor};color: ${textColor};${
        isThemeColor ? themeColor : ''
      }`
    "
  >
    <slot />
  </div>
</template>

<script>
const themeColor =
  "background:rgba(253,215,0,1);border: 1px solid rgba(253,215,0,1)";

export default {
  name: "MlButton",
  props: {
    width: {
      type: String,
      default: "150px"
    },
    isThemeColor: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    borderColor: {
      type: String,
      default: ""
    },
    textColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      themeColor
    };
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    }
  }
};
</script>

<style lang="scss" scoped>
._ml-button {
  width: 100%;
  height: 40px;
  border-radius: 21px;
  border: 1px solid rgba(36, 36, 36, 1);
  font-size: 15px;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  background: #fff;
  line-height: 40px;
  text-align: center;
}
</style>
